export default {
    details: {
        order_id: {
            icon: 'mdi-receipt',
            label: 'Order ID',
            type: 'text',
            color: 'success',
            copy: true,
            order: 1,
        },
        type: {
            icon: 'mdi-clipboard-account',
            label: 'Type',
            type: 'text',
            color: 'success',
            copy: false,
            order: 2,
        },
        assigned_to: {
            icon: 'mdi-account-check',
            label: 'Assigned to',
            type: 'text',
            color: 'success',
            copy: false,
            order: 3,
        },
        products: {
            icon: 'mdi-tag',
            label: 'Product',
            type: 'text',
            color: 'success',
            copy: false,
            order: 4,
        },
        property: {
            icon: 'mdi-domain',
            label: 'Property',
            type: 'text',
            color: 'success',
            copy: false,
            order: 5,
        },
        source: {
            icon: 'mdi-clipboard-arrow-right',
            label: 'Source',
            type: 'text',
            color: 'success',
            copy: false,
            order: 6,
        },
    },
    status: {
        APPLICANT_SUBMITTED: {
            label: 'App Submitted',
            color: 'warning',
            status: 'APPLICANT_SUBMITTED',
        },
        APPLICANT_STARTED: {
            label: 'App Started',
            color: 'info',
            status: 'APPLICANT_STARTED',
        },
        APPLICANT_PENDING: {
            label: 'App Pending',
            color: 'warning',
            status: 'APPLICANT_PENDING',
        },
        APPLICANT_APPROVED: {
            label: 'App Approved',
            color: 'info',
            status: 'APPLICANT_APPROVED',
        },
        APPLICANT_DENIED: {
            label: 'App Denied',
            color: 'error',
            status: 'APPLICANT_DENIED',
        },
        APPLICANT_INVITED: {
            label: 'App Invited',
            color: 'info',
            status: 'APPLICANT_INVITED',
        },
        APPLICANT_REMINDED: {
            label: 'App Reminded',
            color: 'info',
            status: 'APPLICANT_REMINDED',
        },
        APPLICANT_COMPLETED: {
            label: 'App Completed',
            color: 'info',
            status: 'APPLICANT_COMPLETED',
        },
        SCREEN_CREATED: {
            label: 'Screen Created',
            color: 'warning',
        },
        SCREEN_PENDING: {
            label: 'Screen Pending',
            color: 'warning',
            status: 'SCREEN_PENDING',
        },
        SCREEN_ERROR: {
            label: 'Screen Error',
            color: 'error',
            status: 'SCREEN_ERROR',
        },
        SCREEN_IN_PROCESS: {
            label: 'Screen Processing',
            color: 'info',
            status: 'SCREEN_IN_PROCESS',
        },
        SCREEN_COMPLETED: {
            label: 'Screen Completed',
            color: 'success',
            status: 'SCREEN_COMPLETED',
        },
        SCREEN_GATED: {
            label: 'Screen Gated',
            color: 'warning',
            status: 'SCREEN_GATED',
        },
        SCREEN_ON_HOLD: {
            label: 'Screen On Hold',
            color: 'info',
            status: 'SCREEN_ON_HOLD',
        },
    },
    application_details: {
        'application.property.name': {
            icon: 'mdi-domain',
            label: 'Property',
            type: 'text',
        },
        'application.unit': {
            icon: 'mdi-door',
            label: 'Unit',
            type: 'text',
        },
        'application.rent': {
            icon: 'mdi-currency-usd',
            label: 'Rent Amount',
            format: 'currency',
            type: 'text',
        },
        submitted_at: {
            icon: 'mdi-calendar',
            label: 'Date Submitted',
            type: 'text',
        },
        'application.source': {
            icon: 'mdi-clipboard-arrow-right-outline',
            label: 'Source',
            type: 'text',
        },
        'application.meta.desired_movein': {
            icon: 'mdi-calendar-arrow-right',
            label: 'Desired Move In',
            type: 'text',
        },
    },
    applicant_profile: {
        type: {
            icon: 'mdi-account-star',
            label: 'Type',
            type: 'text',
        },
        phone: {
            icon: 'mdi-phone',
            label: 'Phone',
            type: 'text',
        },
        email: {
            icon: 'mdi-email',
            label: 'Email',
            type: 'text',
        },
        birthdate: {
            icon: 'mdi-cake-variant',
            label: 'Birthdate',
            type: 'text',
        },
        ssn_mask: {
            icon: 'mdi-account-lock-outline',
            label: 'SSN',
            type: 'text',
        },
        itin_mask: {
            icon: 'mdi-account-lock-outline',
            label: 'ITIN',
            type: 'text',
        },
    },
};
